/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable ember/no-classic-classes */
import EmberRouter from '@ember/routing/router';
import config from './../../config/environment';
import EmbercomBootDataModule from 'embercom/lib/embercom-boot-data';
import { setSentryTagsFromTransition } from 'embercom/lib/sentry';
import { timeout } from 'ember-concurrency';
import { task } from 'ember-concurrency-decorators';
import { inject as service } from '@ember/service';
import ENV from 'embercom/config/environment';
import { isReactRoute } from 'embercom/lib/react-route';

const IS_EMBERCOM = !EmbercomBootDataModule.isBootedInPublicPage();

export default class EmbercomRouter extends EmberRouter {
  rootURL = IS_EMBERCOM ? config.rootURL : EmbercomBootDataModule.publicPageRootUrl();
  location = config.locationType;

  @service appService;
  @service reactTeammateAppIsland;

  @task({ keepLatest: true }) *ping() {
    if (this.appService?.app?.canUseFinSuccessAgentExperimentFinStudio) {
      window.Intercom('update', { last_request_at: Math.floor(Date.now() / 1000) });
    } else {
      window.Intercom('update');
    }

    yield timeout(ENV.APP._5000MS);
  }

  init() {
    super.init(...arguments);
    this.on('routeWillChange', (transition) => {
      // When moving from React to Ember, hide React content immediately but don't do full transition handling
      if (this.isMovingFromReactToEmber(transition)) {
        this.reactTeammateAppIsland.hideReactContent();
      }
      setSentryTagsFromTransition(transition);
    });

    this.on('routeDidChange', (transition) => {
      setSentryTagsFromTransition(transition);
      if (transition && transition.from?.name !== transition.to?.name) {
        // Strip hide_default_launcher before pinging — the ping re-reads
        // intercomSettings and can re-apply a stale true left by Inbox
        // components. See: https://github.com/intercom/intercom/issues/409087
        if (window.intercomSettings) {
          delete window.intercomSettings.hide_default_launcher;
        }
        this.ping.perform();
      }

      // Always handle transition once here, regardless of React to Ember movement
      this.reactTeammateAppIsland.handleTransition(transition);
    });
  }

  isMovingFromReactToEmber(transition) {
    return isReactRoute(transition.from) && !isReactRoute(transition.to);
  }

  static map() {
    if (IS_EMBERCOM) {
      super.map(...arguments);
    } else if (EmbercomBootDataModule.isBootedInPublicAppStoreMode()) {
      super.map(function () {
        this.route('appstore', { path: '/' }, function () {
          this.route('app-package', { path: 'apps/:id' });
          this.route('not-found', { path: '*path' });
        });
      });
    } else if (EmbercomBootDataModule.isBootedInMeetingScheduler()) {
      super.map(function () {
        this.route('meeting-scheduler', { path: ':id' });
        this.route('meeting-scheduler', { path: ':id/:duration' });
      });
    }
  }
}
